const AUTH_ROUTES = ["/signin", "/forgot-password"];
const BASE_URL = normalizeBaseUrl(import.meta.env.BASE_URL);

function normalizeBaseUrl(baseUrl: string): string {
  if (!baseUrl || baseUrl === "/") {
    return "/";
  }

  const withLeadingSlash = baseUrl.startsWith("/") ? baseUrl : `/${baseUrl}`;
  return withLeadingSlash.endsWith("/") ? withLeadingSlash : `${withLeadingSlash}/`;
}

function stripBasePath(pathname: string): string {
  if (BASE_URL === "/") {
    return pathname || "/";
  }

  const basePath = BASE_URL.slice(0, -1);
  if (pathname === basePath) {
    return "/";
  }

  if (pathname.startsWith(`${basePath}/`)) {
    return pathname.slice(basePath.length) || "/";
  }

  return pathname || "/";
}

function withBasePath(path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (BASE_URL === "/") {
    return normalizedPath;
  }

  const basePath = BASE_URL.slice(0, -1);
  if (normalizedPath === "/") {
    return `${basePath}/`;
  }

  return `${basePath}${normalizedPath}`;
}

/**
 * 등록된 경로 외 직접 진입은 안내 페이지(404.html — 404 문구 없는 잘못된 접근 안내)로
 * 통일한다. 흰 화면이나 홈 이동 등 앱마다 다르던 동작을 막는다.
 * 뒤로/앞으로(popstate)는 앱 내 상태 복원이므로 검사하지 않는다.
 */
function isKnownPath(path: string): boolean {
  const normalized = path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
  if (normalized === "/" || normalized === "/index.html" || normalized === "/change-password") {
    return true;
  }
  return AUTH_ROUTES.includes(normalized);
}

export function createRouterStore() {
  return {
    path: stripBasePath(window.location.pathname),
    tab: window.location.hash.replace("#", "") || "",

    init() {
      if (!isKnownPath(this.path)) {
        window.location.replace(withBasePath("/404.html"));
        return;
      }
      window.addEventListener("popstate", () => {
        this.path = stripBasePath(window.location.pathname);
        this.tab = window.location.hash.replace("#", "") || "";
      });
    },

    navigate(to: string) {
      if (to === this.path) {
        return;
      }
      history.pushState(null, "", withBasePath(to));
      this.path = to;
      this.tab = window.location.hash.replace("#", "") || "";
    },

    navigateTab(tabId: string) {
      const hash = `#${tabId}`;
      if (window.location.hash === hash) {
        return;
      }
      history.pushState(null, "", `${withBasePath("/")}${hash}`);
      this.tab = tabId;
    },

    isDashboardRoute(): boolean {
      return this.path === "/" || this.path === "";
    },

    handleAuthRedirect(isLoading: boolean, authenticated: boolean, requiresPasswordChange = false) {
      if (isLoading) {
        return;
      }

      const isAuthRoute = AUTH_ROUTES.includes(this.path);
      const isChangePwRoute = this.path === "/change-password";

      if (!(authenticated || isAuthRoute)) {
        this.navigate("/signin");
      } else if (authenticated && requiresPasswordChange && !isChangePwRoute) {
        this.navigate("/change-password");
      } else if (authenticated && !requiresPasswordChange && isChangePwRoute) {
        this.navigate("/");
      } else if (authenticated && !requiresPasswordChange && isAuthRoute) {
        this.navigate("/");
      }
    },
  };
}
